import { IBroadcastInfo } from "@home-health-notify/domain";
import InfoIcon from "@mui/icons-material/Info";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "hhn-commons";
import React, { useContext } from "react";
import { RightDrawerContext } from "../../../context/RightDrawerContext";
import {
  ActionIcons,
  BroadcastHeaderWrapper,
  HeaderDescriptionWrapper,
} from "../../MessageHeader.style";
import { CommonChatHeaderDescription } from "../CommonChatHeaderDescription";
import { useSnackbar } from "notistack";
import { LoadingOverlay } from "../commonHeader/GroupHeader.style";

export const BroadcastHeader = ({
  broadcastInfo,
  isChatLoading,
}: {
  broadcastInfo: IBroadcastInfo;
  isChatLoading: boolean;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  const tNsInfo = (key: string) => t(key, { ns: "groupChatInfo" });
  const {
    openAddMembersDrawer,
    openChatInfoDrawer,
    closeDrawer,
    open: chatInfoDrawerOpen,
  } = useContext(RightDrawerContext);
  const { enqueueSnackbar } = useSnackbar();

  const openAddMembers = () => {
    if (isChatLoading) return;
    openAddMembersDrawer(broadcastInfo, false);
  };

  const toggleChatInfoDrawer = () => {
    !chatInfoDrawerOpen ? openChatInfoDrawer() : closeDrawer();
  };

  const onChatInfoClick = () => {
    if (isChatLoading) return;
    toggleChatInfoDrawer();
  };

  const showLoadingSnackbar = () => {
    enqueueSnackbar(tNsInfo("chatInfoLoading"), {
      autoHideDuration: 3000,
    });
  };

  return (
    <BroadcastHeaderWrapper data-testid="broadcast-header-component">
      <LoadingOverlay
        isLoading={isChatLoading}
        onClick={showLoadingSnackbar}
        data-testid="loading-overlay"
      />
      <HeaderDescriptionWrapper onClick={onChatInfoClick}>
        <CommonChatHeaderDescription chatInfo={broadcastInfo} />
      </HeaderDescriptionWrapper>
      <ActionIcons>
        <IconButton onClick={openAddMembers} disableTouchRipple>
          <Tooltip title={tNs("addMember")}>
            <PersonAddAlt1Icon data-testid="add-members" />
          </Tooltip>
        </IconButton>
        <IconButton onClick={onChatInfoClick} disableTouchRipple>
          <Tooltip title={tNs("chatInfo")}>
            <InfoIcon data-testid="chatInfo-btn" />
          </Tooltip>
        </IconButton>
      </ActionIcons>
    </BroadcastHeaderWrapper>
  );
};
